import { Observable } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { AuthService } from '../../../auth/auth.service';
import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import { currentMainState } from '../game-plan.state';
import { GamePlanService } from '../service/game-plan.service';

export function loadPlaybook(): Observable<void> {
    const authService = epicDependencies.injector.get<AuthService>(AuthService);
    const gpService =
        epicDependencies.injector.get<GamePlanService>(GamePlanService);

    const state = currentMainState();

    state.loading = true;

    return gpService.retrievePlaybook(authService.user.id).pipe(
        tap((ret) => {
            ret.rows.forEach((row) => {
                // if (row.wpWinning != null && row.wpWinning >= 1) {
                //     row.wpStatus = 'on-target';
                // } else if (row.wpNeutral != null && row.wpNeutral >= 1) {
                //     row.wpStatus = 'missing-target';
                // } else if (row.wpLosing != null && row.wpLosing >= 1) {
                //     row.wpStatus = 'below-target';
                // }

                // if (
                //     row.wpStatus === 'missing-target' ||
                //     row.wpStatus === 'below-target'
                // ) {
                //     row.actions ??= [];
                //     row.actions.push({
                //         userId: row.userId,
                //         type: 'review',
                //         draftId: null,
                //         approvalId: null,
                //         commitmentId: null,
                //         eventCentreCategoryId: null,
                //         eventCentreItemId: null,
                //         behaviourName: null,
                //         subBehaviourName: null,
                //         metrics: null,
                //     });
                // }

                row.actions?.forEach((action) => {
                    action.metrics?.forEach((metric) => {
                        metric.estimatedCompletionDate =
                            metric.estimatedCompletionDate == null
                                ? null
                                : new Date(metric.estimatedCompletionDate);
                    });
                });

                row.opportunities?.sort(
                    (a, b) =>
                        (a.percentToTarget ?? Number.MAX_SAFE_INTEGER) -
                        (b.percentToTarget ?? Number.MAX_SAFE_INTEGER),
                );
            });

            state.playbook = ret;
        }),
        catchErrorLogRet(null),
        tap(() => {
            state.loading = false;
        }),
        mapTo(null),
    );
}
